import { dataHeadphonesSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHeadphonesSolid = /*#__PURE__*/createIcon(dataHeadphonesSolid)
export default IconHeadphonesSolid
